export default "__VITE_ASSET__tMhcwbdQ__"